/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsuranceCarrier/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2InsuranceSubscription from 'DesignSystem/Svgs/Tysiav2InsuranceSubscription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InsuranceCarrier({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/InsuranceCarrier"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let assignDetailsInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'insurance_company.carrier_name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="InsuranceCarrier.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2InsuranceSubscription
  viewPath={`${viewPath}/Tysiav2InsuranceSubscription`}
 height={20}
 width={20}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={120}
 marginLeft={dtSpaceXxs}
 text="Insurance Carrier"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 data="assign_details.insurance_company.carrier_name"
 text={assignDetailsInsuranceCompanyCarrierNameValueData}
/>
</div>
{children}
</React.Fragment>)
}